import React , {useState, useEffect} from 'react';
import ImageButton from './imageButton';


const ChatRoomsList = ({uid, 
                      channel, 
                      roomList, 
                      server_host, 
                      selectedRoom,
                      setRoomList }) => {
// set the selected room in second position of roomList
const [isScrollingRooms, setIsScrollingRooms] = useState(false)

useEffect(() => {
// Définir les écouteurs d'événements de Socket.io
const handleRoomsListChanged = (user_id, rList) => {
    if (user_id != uid) {
      return
    }
    console.log(roomList)
    console.log(rList)
    setRoomList(rList)
  }

const handleNewRoom = (user_id, room) => {
    if (user_id != uid) {
      return
    }
    console.log('new available room ' + room)
    setRoomList((prevRooms) => {
      const or = prevRooms.findIndex((m) => m.name === room.name)
      if (or === -1)
        return [...prevRooms, room]
      else
        return prevRooms
    })
    
  }

  channel.on('rooms list', handleRoomsListChanged);

  channel.on('available room', handleNewRoom);


   }, [])
    /*
    channel.on('room joined', (roomId, description, parentMessage, point_message, user, mmap, is_owner, is_coach) => {
      if ((user === uid) || (user === 'leaded move')) {
        // setSelectedRoom(roomId)
        // setIsOwner(is_owner)
        // setIsCoach(is_coach)
      }
  });
     */

const handleSelect = (roomObj) => {
  // setSelectedRoom(room)
  setIsScrollingRooms(false)
  const room = roomObj.name
  channel.emit('join conversation', {room, uid})
};

const rollOptions = (direction) => {
  setIsScrollingRooms(true)
  if (direction === 'left') {
    setRoomList((prevList) => {
      return [...prevList.slice(1), prevList[0]]
    }) 
  } else if (direction === 'right') {
    setRoomList((prevList) => {
      return [...prevList.slice(-1), ...prevList.slice(0, -1)]
    }) 
  }
}

const handleScroll = (event) => {
  // Exemple de gestion de l'événement de défilement
  if (event.deltaY > 0) {
    rollOptions('right')
  } else {
    rollOptions('left')
  }
};

useEffect(() => {
if (!isScrollingRooms && selectedRoom !== undefined) {
  let position = roomList.findIndex((r) => r.name === selectedRoom)
  if  (position > 1 ) {
    position -= 1
    rollOptions('right')
  }
}
}, [roomList, isScrollingRooms]);

  let protocol = process.env.REACT_APP_PROTOCOL
  if (protocol === undefined){
    protocol = "http"
  }



return (
  <div className="horizontal-carousel-header">
    <h3> </h3>
    <div className="horizontal-carousel" key={selectedRoom}>
    {(roomList.length > 2) && <button className="horizontal-carousel-button" scale='.6' border-radius='10%' max-height='1px' onClick={() => rollOptions('left')}>&#x25C0;</button>}
    <div className="options-container" onWheel={handleScroll}>
      {roomList.slice(0, 3).map((option, index) => (
        <div
          key={option.name}
          className={`roomlist_option ${option.name === selectedRoom ? 'active' : ''}`}
          onClick={() => handleSelect(option)}
        >
        {
          (option.type === 'coaching' && option.is_owner)? (
            <ImageButton
              url={`${protocol}://${server_host}:3050/images/users.svg`} onClick={() => handleSelect(option)} size='small' title={`coach d'un coaching\n(${option.map_name})'`} color='green'/>
          ) : 
          (option.type === 'standard')? (
            <ImageButton
              url={`${protocol}://${server_host}:3050/images/users.svg`} onClick={() => handleSelect(option)} size='small' title={`discussion libre\n${option.map_name}`} color='white'/>
            ) : 
            (option.type === 'interview')? (
              <ImageButton
                url={`${protocol}://${server_host}:3050/images/users.svg`} onClick={() => handleSelect(option)} size='small' title={`interview\n${option.map_name}`} color='white'/>
              ) : 
              (option.type === 'interview'  && option.is_owner)? (
                <ImageButton
                  url={`${protocol}://${server_host}:3050/images/users.svg`} onClick={() => handleSelect(option)}size='small' title={`interviewer d'interview\n${option.map_name}`} color='pink'/>
              ) :     
        (option.type === 'boussole')? (
          <ImageButton
            url={`${protocol}://${server_host}:3050/images/users.svg`} onClick={() => handleSelect(option)}size='tiny' title={`coaching\n${option.map_name}`} color='lightgreen'/>
      ) : 
          (' ')
        }
        {option.name}
        </div>
      ))}
      </div>
      {(roomList.length > 2) && <button className="horizontal-carousel-button" scale='.6' border-radius='10%' onClick={() => rollOptions('right')}>&#x25B6;</button>}
    </div>

  </div>
);

};

export default ChatRoomsList;